import RegistrationList from "./RegistrationList"
import RegistrationListContainer from "./RegistrationListContainer"
import RegistrationListItem from "./RegistrationListItem"

export default {
  Container: RegistrationListContainer,
  List: RegistrationList,
  Item: RegistrationListItem
}
